import { render, staticRenderFns } from "./OvertimeDetail.vue?vue&type=template&id=632c976b&scoped=true&"
import script from "./OvertimeDetail.vue?vue&type=script&lang=js&"
export * from "./OvertimeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632c976b",
  null
  
)

export default component.exports